import { ObjectIdSchema } from '@vy/types';
import { oz } from '@vy/utils';

export const ApplyCreditFormSchema = oz.object({
  amount: oz.number().positive(),
  invoiceId: ObjectIdSchema,
  customerId: ObjectIdSchema,
  contractId: ObjectIdSchema.optional(),
  erpId: oz.string().optional(),
  description: oz.string().optional(),
});

export type ApplyCreditFormValues = oz.infer<typeof ApplyCreditFormSchema>;
